<template>
	<ui-modal
		:name="getModalName"
		:load-success="loader.modalLoadSuccess"
		:load-fail="loader.modalLoadError"
		:load="loader.modalLoad"
		:title="`Editar ${title}`"
		icon="fal fa-tags"
		size="xs"
	>
		<div class="modal-content">
			<div class="new-tag">
				<ui-input label="Label" v-model="form.label" required />

				<ui-select-2
					v-model="form.type"
					:data="typeOptions"
					:search="false"

					label="Tipo"
					item-label="label"
					return-value="value"

					required
				/>
			</div>
		</div>

		<template #footer>
			<div class="hide-me">&nbsp;</div>
			<ui-modal-cancel-button :modalName="getModalName">Cancelar</ui-modal-cancel-button>
			<ui-button
				:disabled="!canSubmit"
				type="button"
				design="md success mw-100"
				@click="submit"
				>{{ config.btnSubmit }}</ui-button
			>
		</template>
	</ui-modal>
</template>

<script>
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSelect2, uiInput 							  	} from '@/components/ui/form'
	import { uiButton 										  	} from '@/components/ui/buttons'
	import { alertMixin, modalMixin, loaderMixin				} from '@/mixins'
	import { mapGetters 									  	} from 'vuex'

	const defaultFormData = () => ({
		id: null,
		label: null,
		type: null
	})

	const defaultTypeOptions = () => ([
		{
			value: 'system',
			label: 'Sistêmica'
		},
		{
			value: 'user',
			label: 'Usuário'
		}
	])

	const defaultLoader = () => ({
		modalLoadSuccess: false,
		modalLoadError: false,
		modalLoad: false
	})

	const defaultConfig = () => ({
		btnSubmit: 'Criar'
	})

	export default {
		name: 'ui-new-tag-modal',

		components: {
			uiModal,
			uiModalCancelButton,
			uiSelect2,
			uiInput,
			uiButton
		},
		mixins: [alertMixin, modalMixin, loaderMixin],
		props: {
			name: {
				type: String,
				require: true
			},
			service: {
				type: String,
				required: true
			},
			title: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				form: { ...defaultFormData() },
				loader: { ...defaultLoader() },
				oldForm: { ...defaultFormData() },
				typeOptions: [ ...defaultTypeOptions() ],
				config: { ...defaultConfig() },

				api: null
			}
		},

		async mounted() {
			try {
				const response = await this.loadService()
				this.api = response.default.build()
			} catch (error) {
				console.error(error)
			}


			this.$root.$on('modal-open-' + this.name, async (tag) => {
				this.reset()

				if (tag) {
					this.form.id = tag.id
					this.form.type = tag.type
					this.form.label = tag.label
					this.config.btnSubmit = 'Salvar'
				}

				this.copyOldTag()
			})
		},

		computed: {
			...mapGetters('auth', {
				user: 'getUser'
			}),


			getModalName() {
				return this.name
			},

			canSubmit() {
				return this.isFormChanged
			},

			isFormChanged() {
				const { id, label, type } = { ...this.form }
				return JSON.stringify({ id, label, type }) != JSON.stringify(this.oldForm)
			},


			disabledTypeTag() {
				return !this.typeOptions.length || (this.user.user_group === 'broker')
			},

			loadService() {
				return () => import('@/services/axios/modules/' + this.service + '.js')
			}
		},

		methods: {

			copyOldTag() {
				const { id, label, type } = { ...this.form }
				this.oldForm = { id, label, type }
			},

			reset() {
				this.form = { ...defaultFormData() }
				this.loader = { ...defaultLoader() }
				this.oldForm = { ...defaultFormData() }
				this.config = { ...defaultConfig() }
			},

			async submit() {
				if (!this.canSubmit) return
				this.$mx_setLoader('modalLoad', true)
				const response = await this.api.createV2(this.form.id, { ...this.form })
				.then(() => {
					this.$mx_setLoader('modalLoadSuccess', true)
					this.$emit('success')
					this.$mx_alertSuccess('Atualizado com sucesso!')
					setTimeout(() => {
						this.$mx_closeModal()	
					}, 1000);
				})
				.catch((error) => {
					this.$mx_setLoader('modalLoadError', true)
					this.$mx_alertError(error.data.msg)
					setTimeout(() => {
						this.$mx_closeModal()	
					}, 1000);
					return
				})	
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
